export default "__VITE_ASSET__ChtSIu2K__"